import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import ponduranceIcon from '@/assets/pondurance-horizontal-mini.svg';

import type { PonduranceIconProps } from './PonduranceIcon.types';

const PonduranceIcon = ({
  background = false,
  offset = false,
  size = 'md'
}: PonduranceIconProps) => {
  const theme = useTheme();
  const sx = {
    alignItems: 'center',
    backgroundColor: background
      ? theme.vars.palette.background.paper
      : 'transparent',
    borderRadius: '50%',
    display: 'flex',
    height: '1.25rem',
    justifyContent: 'center',
    width: '1.25rem',
    '& > img': {
      height: '1rem'
    },
    ...{ ...(offset && { position: 'absolute', right: -4, bottom: -3 }) }
  };

  switch (size) {
    case 'sm':
      sx.height = '0.875rem';
      sx.width = '0.875rem';
      sx['& > img'] = {
        height: '0.625rem'
      };
      break;
    case 'lg':
      sx.height = '1.625rem';
      sx.width = '1.625rem';
      sx['& > img'] = {
        height: '1.475rem'
      };
      break;
    default:
      sx.height = '1.25rem';
      sx.width = '1.25rem';
      sx['& > img'] = {
        height: '1rem'
      };
      break;
  }

  return (
    <Box sx={sx}>
      <img src={ponduranceIcon} alt="Pondurance Logo" />
    </Box>
  );
};

export default PonduranceIcon;
